import Email from "./img/Email.svg"
import Github from "./img/Github.svg"
import Linkedin from "./img/Linkedin.svg"
import Logo from "./img/logo.png"
import Hero from "./img/hero.png"
import Fruto from "./img/fruto.png"
import Financeiro from "./img/financeiro.png"
import Organo from "./img/organo.png"
import Amigos from "./img/amigos.png"
import StreetWise from "./img/streetwise.jpg"
import InkDash from "./img/inkdash.jpg"
import GeoSO from "./img/geoso.jpg"
import RunGo from "./img/rungo.png"

export const colorData = {
    primary: "hsl(287 60% 65%)",
    primaryOp: "hsl(287 60% 65%/0.1)",
    gray: "hsl(219 14% 71%)",
    grayOp: "hsl(219 14% 71%/0.1)",
    background: "hsl(218 12% 18%)",
    white: "hsl(0 0% 100%)"
}

export const fontData = {
    fontPrimary: '"Fira Code", monospace'
}

export const logoImage = {
    logo: Logo
}

export const mediaIcons = {
    email: {
        href: "mailto:denys.fukami@gmail.com",
        src: Email,
        alt: "email"
    },

    github: {
        href: "https://github.com/hideakifukami",
        src: Github,
        alt: "github"
    },

    linkedin: {
        href: "https://www.linkedin.com/in/hideaki-fukami/",
        src: Linkedin,
        alt: "linkedin"
    }
}

export const heroData = {    
    image: {
        src: Hero,
        alt: "Fotografia de Hideaki Fukami"
    },
    href: "https://github.com/GreeeenDevs/baronesa-petshop"
}

export const ProjectData = {
    project1: {
        src: Fruto,
        alt: "Banner do projeto Fruto e Fruta",
        techs: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "Bootstrap",
            tech4: ""
        },
        name: "Landing Page - Fruto & Fruta",
        description: "Projeto de Landing Page responsiva construído com uso de Bootstrap.",
        hrefLive: "https://hideakifukami.github.io/fruto-fruta-project/",
        hrefGit: "https://github.com/hideakifukami/fruto-fruta-project",
    },

    project2: {
        src: Financeiro,
        alt: "Banner do projeto Controle Financeiro",
        techs: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "JavaScript",
            tech4: "React.JS"
        },
        name: "Controle Financeiro - React.JS",
        description: "Projeto construído com uso de React.JS, de forma responsiva e utilizando as bibliotecas react-icons e styled-components.",
        hrefLive: "https://controle-financeiro-reactjs.vercel.app/",
        hrefGit: "https://github.com/hideakifukami/controle-financeiro-reactjs",
    },

    project3: {
        src: Organo,
        alt: "Banner do projeto Organo",
        techs: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "JavaScript",
            tech4: "React.JS"
        },
        name: "Organo Project - React.JS",
        description: "Projeto elaborado com uso de React.JS para elaboração dos componentes da página de forma individual e com interação dinâmica.",
        hrefLive: "https://organo-project-hideakifukami.vercel.app/",
        hrefGit: "https://github.com/hideakifukami/organo-project",
    },

    project4: {
        src: Amigos,
        alt: "Banner do projeto Amigos do Bairro",
        techs: {
            tech1: "HTML",
            tech2: "CSS",
            tech3: "JavaScript",
            tech4: ""
        },
        name: "Amigos do Bairro",
        description: "Projeto Interdisciplinar I - Website para o coletivo Amigos do Bairro.",
        hrefLive: "https://hideakifukami.github.io/amigos-do-bairro/pages/index.html",
        hrefGit: "https://github.com/hideakifukami/amigos-do-bairro",
    },

    project5: {
        src: StreetWise,
        alt: "Banner do projeto Street Wise",
        techs: {
            tech1: "Node.js",
            tech2: "Express",
            tech3: "React.JS",
            tech4: ""
        },
        name: "StreetWise Tattoo Service",
        description: "Projeto Interdisciplinar II - Serviço de API RESTful para gerenciamento de um estúdio de tatuagem (StreetWise).",
        hrefLive: "https://ibb.co/album/3vc5Tk",
        hrefGit: "https://github.com/TechWeavers/tattoo-service-nodejs",
    },

    project6: {
        src: InkDash,
        alt: "Banner do projeto InkDash",
        techs: {
            tech1: "Python",
            tech2: "React.JS",
            tech3: "",
            tech4: ""
        },
        name: "Inkdash ERP",
        description: "Projeto Interdisciplinar III - Sistema ERP completo para gerenciamento de estúdio de tatuagem, incluindo front-end em React e backend de gestão.",
        hrefLive: "https://ibb.co/album/Qj7wjW",
        hrefGit: "https://github.com/TechWeavers/PI-StreetWise-ERP-3Semestre",
        hrefGit2: "https://github.com/TechWeavers/tattoo-management-react"
    },

    project7: {
        src: GeoSO,
        alt: "Banner do projeto GeoSO",
        techs: {
            tech1: "Node.js",
            tech2: "React.JS",
            tech3: "Firebase",
            tech4: ""
        },
        name: "GeoSO App",
        description: "Projeto Interdisciplinar IV - Site para geolocalização e acesso a postos públicos de coleta",
        hrefLive: "https://ibb.co/album/d7zhDb",
        hrefGit: "https://github.com/GreeeenDevs/geoso-app/tree/main",
    },

    project8: {
        src: RunGo,
        alt: "Banner do projeto RunGo",
        techs: {
            tech1: "React Native",
            tech2: "TypeScript",
            tech3: "",
            tech4: ""
        },
        name: "RunGo App",
        description: "Projeto Interdisciplinar V - Aplicativo mobile para gameficação de exercício físico.",
        hrefLive: "https://www.youtube.com/shorts/d7CnZjd0z44",
        hrefGit: "https://github.com/GreeeenDevs/rungo-app",
    }
}

export const footerData = {
    hrefEmail: 'mailto:denys.fukami@gmail.com',
    email: 'denys.fukami@gmail.com',
    description: 'Desenvolvedor de software multiplataforma residindo no Brasil.',
    title: 'Media',
    copyright: 'Copyright 2023. Made by Hideaki Fukami'
}

export const skillsData = {
    languages: {
        skillGroup: "Languages",
        skills: {
            item1: 'JavaScript',
            item2: 'Python',
            item3: 'Java'
        }
    },

    other: {
        skillGroup: "Other",
        skills: {
            item1: 'HTML',
            item2: 'CSS',
            item3: 'Photoshop',
            item4: 'Illustrator',
            item5: 'Figma',
            item6: 'Git'
        }
    },

    frameworks: {
        skillGroup: "Frameworks",
        skills: {
            item1: 'React',
            item2: 'Bootstrap',
            item3: 'Three.JS'
        }
    }
}

export const curriculoData = {
    certificados: {
        group: "Certificados",
        certificados: {
            item1: "4Linux - CI/CD: Integração e entrega continua com Jenkins, Nexus, Sonarqube, Gitlab-ci e Github actions",
            item2: "4Linux - Terraform na Prática - Especialista em Provisionamento Cloud na GCP",
            item3: "4Linux - Especialista em Automação com Ansible - LC",
            item4: "4Linux - Cloud Services Administrator: AWS, GCP, Azure - LC",
            item5: "4Linux - Infraestrutura Ágil com Práticas DevOps - LC",
            item6: "4Linux - OpenShift: Administração PaaS em Containers",
            item7: "4Linux - Kubernetes: Orquestração de Ambientes Escaláveis - CKA - LC",
            item8: "4Linux - Docker: Administração de Containers - DCA - LC",
            item9: "Cisco - ENDPOINT SECURITY",
            item10: "IBM - IBM Cloud Technical Advocate Foundations V2",
            item11: "IBM - IBM Certified Technical Advocate - Cloud v4",
            item12: "IBM - Principles of IBM Cloud Professional Developer V2",
            item13: "IBM - Essentials of IBM Cloud Professional Developer V2"
        }
    },

    profissional: {
        group: "Experiência Profissional",
        profissional: {
            item1: "Suporte à Infraestrutura em Nuvem Pública - Caixa Econômica Federal - 11/2025 - Atual"
        }
    },

    educacional: {
        group: "Formação Educacional",
        educacional: {
            item1: "Letras - USP - 2014 - 2017 (incompleto)",
            item2: "Ciências Sociais - UNIFESP - 2018 - 2018 (incompleto)",
            item3: "Desenvolvimento de Software Multiplataforma - FATEC - 2023 - atual (cursando)"
        }
    },

    linguas: {
        group: "Línguas",
        linguas: {
            item1: "Português - Nativo",
            item2: "Inglês - Intermediário",
            item3: "Japonês - Básico"
        }
    }
}